"use strict";
// Savings-goal type definitions — the single source-of-truth contract for the
// Goals page + dashboard Goals card, shared by web (Vite) and mobile (Expo).
//
// UI-facing camelCase shapes. The web API layer (frontend/src/api/goals.ts)
// mirrors the backend's snake_case response (apps/goals/serializers.py +
// services/summary.py) and adapts it onto these types. Monetary values are JS
// numbers here (the adapter parses the backend's Decimal strings).
//
// NOTE: distinct from mobile's local onboarding `UserGoal` enum (pay_off_debt /
// save_money / …), which is a strategic intent, not a funded savings target.
Object.defineProperty(exports, "__esModule", { value: true });
//# sourceMappingURL=goal.js.map